import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=56640abc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56640abc')) {
      api.createRecord('56640abc', component.options)
    } else {
      api.reload('56640abc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=56640abc&", function () {
      api.rerender('56640abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27x0aHFxeeg0L/JS/pricehelp.vue"
export default component.exports